import React, { useState, useEffect } from "react";
import ComplaintsTable from "./components/ComplaintsTable";
import Divider from "@material-ui/core/Divider";
import View from "./modals/View";
import axios from "axios";
import { v4 as uuid } from "uuid";

export default function Complaints() {
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [deleteComplaintsIds, setDeleteComplaintsIds] = useState([]);
  const [complaint, setComplaint] = useState({});


  const onComplaints = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}complaint?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
      ).catch((error) => {
        setIsLoaded(false);
        setError(true);
        setRows([]);
        setCount(0);
      });
  };

  const onComplaintChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}complaint/${id}`)
      .then(({ data }) => {
        setComplaint(data);
      });
  };



  const onConfirmStatus = (id, status) => {
    axios
      .put(
        `${process.env.REACT_APP_API_URL}complaint`,
        {
          id,
          status
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onComplaints(skip, take, sortField, orderBy);
      });
  };


  useEffect(() => {
    onComplaints(skip, take, sortField, orderBy);
  }, [skip, take, sortField, orderBy]);

  useEffect(() => {
  }, [showView, showEdit]);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Complaints</h1>
      </div>
      <Divider className="w-100" />
      <ComplaintsTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        setDeleteComplaintsID={setDeleteComplaintsIds}
        deleteComplaintsIds={deleteComplaintsIds}
        onConfirmStatus={onConfirmStatus}
        onComplaintChoose={onComplaintChoose}
      />


      <View complaint={complaint} open={showView} onClose={toggleDrawer(false)} />

    </div>
  );
}
